import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, FileCheck, Shield, ShieldCheck, Smartphone } from 'lucide-react';
import { useAuth } from '../components/auth/AuthContext';
import Header from '../components/layout/Header';

const slides = [
  { icon: Shield, title: 'Votre gardien numérique', text: 'Protégez vos transactions, vos messages et votre identité avant de cliquer.' },
  { icon: Smartphone, title: 'Pensé pour WhatsApp', text: 'Collez un lien suspect reçu par message et obtenez une réponse claire en quelques secondes.' },
  { icon: FileCheck, title: 'Des preuves prêtes', text: 'SENTINELLE prépare un rapport et vous aide à signaler les fraudes aux bonnes autorités.' },
];

export default function OnboardingPage() {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();
  const { completeOnboarding } = useAuth();
  const slide = slides[step];
  const Icon = slide.icon;

  const continueFlow = () => {
    if (step < slides.length - 1) {
      setStep(step + 1);
      return;
    }
    completeOnboarding();
    navigate('/register');
  };

  const skip = () => {
    completeOnboarding();
    navigate('/register');
  };

  return (
    <div className="auth-container">
      <Header rightAction={<button type="button" onClick={skip} className="min-h-11 text-text-primary font-medium active:scale-95 transition-transform">Ignorer</button>} />
      <main className="flex-1 flex flex-col justify-between py-8 md:py-12">
        <section className="text-center md:max-w-xl md:mx-auto">
          <div className="mx-auto w-56 h-56 md:w-72 md:h-72 rounded-full bg-brand-navy-light flex items-center justify-center shadow-inner">
            <div className="w-36 h-36 md:w-44 md:h-44 rounded-[32px] bg-white shadow-lg flex items-center justify-center">
              <Icon className="w-20 h-20 md:w-24 md:h-24 text-brand-navy" strokeWidth={1.8} />
            </div>
          </div>
          <h1 className="mt-10 text-2xl md:text-4xl font-extrabold text-brand-navy">{slide.title}</h1>
          <p className="mt-4 text-text-muted leading-relaxed md:text-lg">{slide.text}</p>
          <div className="mt-8 flex justify-center gap-2">
            {slides.map((item, index) => <span key={item.title} className={`h-2 rounded-full ${index === step ? 'w-10 bg-brand-navy' : 'w-2 bg-gray-300'}`} />)}
          </div>
        </section>

        <section className="space-y-3 md:max-w-md md:mx-auto md:w-full">
          <button type="button" onClick={continueFlow} className="btn-primary">Continuer <ArrowRight className="w-5 h-5" /></button>
          <Link to="/login" onClick={completeOnboarding} className="btn-secondary">J'ai déjà un compte</Link>
          <div className="flex justify-center gap-2 text-xs text-text-muted pt-2">
            <ShieldCheck className="w-4 h-4 text-verdict-safe" /> Données protégées et usage confidentiel
          </div>
        </section>
      </main>
    </div>
  );
}
